import { combineReducers } from 'redux'
import { configureStore } from '@reduxjs/toolkit'

import appReducer from '../components/App/appSlice'
import modalsReducer from '../components/Modals/modalsSlice'
import changelogReducer from '../routes/Changelog/changelogSlice'
import overviewReducer from '../routes/Overview/overviewSlice'
import referenceReducer from '../routes/Reference/referenceSlice'

const rootReducer = combineReducers({
  app: appReducer,
  modals: modalsReducer,
  changelog: changelogReducer,
  overview: overviewReducer,
  reference: referenceReducer
})

const store = configureStore({
  reducer: rootReducer
})

export default store